import React, { useEffect, useRef, useState } from "react";
import { posApi } from "./posApi";
import { BellRing, X } from "lucide-react";

// Layer 3 -> POS: polls KDS ready/completed notifications (same polling pattern as approvals).
export default function KdsAlerts({ C }) {
  const [notes, setNotes] = useState([]);
  const [open, setOpen] = useState(false);
  const seen = useRef(new Set());
  useEffect(() => {
    const poll = async () => {
      try {
        const { data } = await posApi.get("/kds/notifications");
        setNotes(data);
        const fresh = data.filter((n) => !seen.current.has(n.id));
        if (fresh.length && seen.current.size) { try { new Audio("data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAIA+AAACABAAZGF0YQAAAAA=").play().catch(() => {}); } catch { /* no audio */ } }
        data.forEach((n) => seen.current.add(n.id));
      } catch { /* offline */ }
    };
    poll(); const iv = setInterval(poll, 5000); return () => clearInterval(iv);
  }, []);
  const ack = async (n) => { try { await posApi.post(`/kds/notifications/${n.id}/ack`); } catch { /* ignore */ } setNotes((x) => x.filter((y) => y.id !== n.id)); };
  const ready = notes.filter((n) => n.status === "ready").length;
  return (
    <div style={{ position: "relative" }}>
      <button onClick={() => setOpen((o) => !o)} data-testid="pos-kds-bell" title="Kitchen updates"
        style={{ background: ready ? "rgba(79,122,82,.12)" : "transparent", border: `1px solid ${ready ? "#bcd6bd" : C.border}`, color: ready ? C.success : C.muted, borderRadius: 9, padding: 9, cursor: "pointer", display: "flex", position: "relative" }}>
        <BellRing size={16} />
        {notes.length > 0 && <span data-testid="pos-kds-badge" style={{ position: "absolute", top: -6, right: -6, background: C.crimson, color: "#fff", borderRadius: 10, fontSize: 10, fontWeight: 700, minWidth: 18, height: 18, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 4px" }}>{notes.length}</span>}
      </button>
      {open && (
        <div data-testid="pos-kds-panel" style={{ position: "absolute", right: 0, top: 44, width: 320, background: "#fff", border: `1px solid ${C.border}`, borderRadius: 14, boxShadow: "0 12px 32px rgba(59,39,34,.15)", zIndex: 50, overflow: "hidden" }}>
          <div className="label" style={{ padding: "10px 14px", fontSize: 11, fontWeight: 700, color: C.muted, borderBottom: `1px solid ${C.border}` }}>KITCHEN UPDATES</div>
          {notes.length === 0 && <div style={{ padding: 18, fontSize: 13, color: C.muted, textAlign: "center" }}>No orders waiting for pickup</div>}
          {notes.map((n) => (
            <div key={n.id} data-testid={`pos-kds-note-${n.order_id}`} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", borderBottom: `1px solid ${C.border}` }}>
              <div>
                <div className="display" style={{ fontWeight: 700, fontSize: 16, color: C.text }}>#{n.order_number} <span style={{ fontSize: 11, fontWeight: 700, color: n.status === "ready" ? C.success : C.muted, marginLeft: 6 }}>{n.status.toUpperCase()}</span></div>
                <div style={{ fontSize: 11.5, color: C.muted }}>{(n.order_type || "").replace("_", " ")} · {n.customer_name || "Walk-in"} · {new Date(n.at).toLocaleTimeString("en-NG", { hour: "2-digit", minute: "2-digit" })}</div>
              </div>
              <button onClick={() => ack(n)} data-testid={`pos-kds-ack-${n.order_id}`} style={{ border: "none", background: "transparent", color: C.muted, cursor: "pointer" }}><X size={16} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
